/* eslint-disable prettier/prettier */

// @mui icons
import Icon from "@mui/material/Icon";

// Your custom components
import Printers from "./layouts/printers";
import Inks from "./layouts/inks";
import SpareParts from "./layouts/spare-parts";
import Orders from "./layouts/orders";
import UsersManagement from "./layouts/users";

// Make sure this path exactly matches where your Login.js is saved!
import Login from "./layouts/authentication/sign-in"; 
import Dashboard from "./layouts/dashboard";

const routes = [
    {
    type: "collapse",
    name: "الرئيسية",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    allowedRoles: ["admin", "employee"], // 🟢 Everyone can see the welcome screen!
  },
  {
    type: "none",
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    component: <Login />,
  },
  {
    type: "collapse",
    name: "مكينات الطباعة",
    key: "printers",
    icon: <Icon fontSize="small">print</Icon>,
    route: "/printers",
    component: <Printers />,
    allowedRoles: ["admin"], // 🟢 Only Admin
  },
  {
    type: "collapse",
    name: "الأحبار",
    key: "inks",
    icon: <Icon fontSize="small">invert_colors</Icon>,
    route: "/inks",
    component: <Inks />,
    allowedRoles: ["admin"], // 🟢 Only Admin
  },
  {
    type: "collapse",
    name: "قطع الغيار",
    key: "spare-parts",
    icon: <Icon fontSize="small">settings_suggest</Icon>,
    route: "/spare-parts",
    component: <SpareParts />,
    allowedRoles: ["admin"], // 🟢 Only Admin
  },
  {
    type: "collapse",
    name: "الطلبات",
    key: "orders",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/orders",
    component: <Orders />,
    allowedRoles: ["admin", "employee"], // 🟢 Both Admin and Employee
  },
  {
    type: "collapse",
    name: "الموظفين",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <UsersManagement />,
    allowedRoles: ["admin"], // 🟢 Only Admin
  },

];

export default routes;